import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api, formatApiError } from '@/lib/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

/**
 * Pagina confermata iscrizione newsletter (doppio opt-in GDPR).
 * Legge ?token=... dall'URL e chiama /api/newsletter/confirm.
 */
export default function NewsletterConfirm() {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const [state, setState] = useState('loading'); // loading|success|error
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setErr('Link non valido'); return; }
    api.get('/newsletter/confirm', { params: { token } })
      .then(r => { setState('success'); setEmail(r.data?.email || ''); })
      .catch(e => { setState('error'); setErr(formatApiError(e)); });
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="newsletter-confirm-page">
      {state === 'loading' && <>
        <Loader2 size={48} className="mx-auto animate-spin text-muted-foreground"/>
        <p className="mt-4 text-muted-foreground">Confermiamo la tua iscrizione…</p>
      </>}
      {state === 'success' && <>
        <div className="inline-flex w-16 h-16 rounded-full bg-chartreuse/20 items-center justify-center">
          <CheckCircle2 size={32} className="text-chartreuse-foreground" style={{ color: 'var(--chartreuse-foreground, #2a6207)' }}/>
        </div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter mt-6">Iscrizione confermata</h1>
        <p className="mt-3 text-muted-foreground">
          {email} è ora iscritta alla newsletter di AgriNexus. Riceverai consigli, nuovi annunci e
          aggiornamenti. Potrai disiscriverti con un click dal footer di ogni email.
        </p>
        <div className="mt-8 flex gap-3 justify-center flex-wrap">
          <Link to="/esplora" className="inline-flex items-center justify-center rounded-full bg-foreground text-background px-6 py-3 text-sm font-medium">Esplora terreni</Link>
          <Link to="/dashboard" className="inline-flex items-center justify-center rounded-full border border-border px-6 py-3 text-sm font-medium">Vai alla dashboard</Link>
        </div>
      </>}
      {state === 'error' && <>
        <div className="inline-flex w-16 h-16 rounded-full bg-destructive/15 items-center justify-center">
          <XCircle size={32} className="text-destructive"/>
        </div>
        <h1 className="font-display text-3xl tracking-tighter mt-6">Link non valido</h1>
        <p className="mt-3 text-muted-foreground">{err || 'Il link di conferma è scaduto, già usato o non più valido.'}</p>
        <Link to="/preferenze" className="inline-block mt-6 underline text-sm">Vai alle preferenze email</Link>
      </>}
    </div>
  );
}
